export default function getCountGoodInOrder(orderGoods, goodId) {
  if (!Array.isArray(orderGoods) || orderGoods.length < 1) return 0;
  const result = orderGoods.filter(i => +i.shopGood === +goodId);
  return result.length === 1 ? result[0].count : 0;
}
